import { render, staticRenderFns } from "./templet.vue?vue&type=template&id=b9e544d6&"
import script from "./templet.vue?vue&type=script&lang=js&"
export * from "./templet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports